<template>
  <section class="containerMobileMenu">
    <div class="containerMobileMenu__overlay" v-if="isMenuOpen" @click="toggleMenuVisibility"></div>
    <section class="containerMobileMenu__menu">
      <circular-button class="containerMobileMenu__menu--mainButton" @click="toggleMenuVisibility" main>
      <template v-slot:icon>
        <span class="icon" :class="{open: isMenuOpen}">
          <span class="icon__line icon__line1"></span>
          <span class="icon__line icon__line2"></span>
          <span class="icon__line icon__line3"></span>
        </span>
      </template>
      </circular-button>
      <section class="containerMobileMenu__menu--menu" :class="{open: isMenuOpen}">
        <div class="menu" @click="toggleMenuVisibility">
          <circular-button v-for="(button, index) in buttons"
                          :key="index"
                          @click.stop="riseEvent(button.pageToOpen)"
                          @clickOutside="toggleMenuVisibility">
            <template v-slot:icon><span :class="[button.icon]"></span></template>
            <template v-slot:label><span class="label">{{button.label}}</span></template>
          </circular-button>
        </div>
      </section>
    </section>
  </section>
</template>

<script>
import circularButton from '../circularButton/circularButton'
import configuration from './mobileMenu.json'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

export default {
  components: {
    circularButton
  },
  setup (props, { emit }) {
    const store = useStore()
    const isMenuOpen = ref(false)
    const buttons = configuration.buttons

    /**
     * @description Toggles the visbility of the mobile menu.
     * @param {Boolean} isOpen flag to know if modal should be open or closed.
     */
    function toggleMenuVisibility (isOpen) {
      isMenuOpen.value = typeof isOpen === 'boolean' ? isOpen : !isMenuOpen.value 
    }

    /**
     * @description Dispatch an event to notify a button has been clicked and a page should be open.
     */
    function riseEvent (appSelected) {
      toggleMenuVisibility(false)
      emit('menuClicked', appSelected)
    }

    return {
      toggleMenuVisibility,
      isMenuOpen,
      buttons,
      riseEvent
    }
  }
}
</script>
